const binding = require('../build/Release/cpufeatures.node');

module.exports = binding.getCPUInfo;
